module.exports = __webpack_public_path__ + "static/img/ISSUE6.9f1fc1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue6/ISSUE6.png
// module id = 3x8A
// module chunks = 7